import { FormProvider } from "react-hook-form";
import TailwindSideModal from "../../../components/commonModal/TailwindSideModal";
import TailwindBottomButtonView from "../../../components/mainBottomButtonView/TailwindBottomButtonView";
import CommonSplitContainer from "../../../components/ui/layout/CommonSplitContainer/CommonSplitContainer";
import CompanyFormFields from "../shared/components/CompanyFormFields";
import CompanyLogoUpload from "../shared/components/CompanyLogoUpload";
import LoadingOverlay from "../shared/components/LoadingOverlay";
import { useCompanyRegisterViewModel } from "./hooks/useCompanyRegisterViewModel";
import { CompanyRegisterModalProps } from "./types/companyRegisterView.types";

/**
 * Tailwind rebuild of the legacy `CompanyRegisterModal`
 * (src/screens/company/companyRegister/CompanyRegisterModal.tsx) on the same
 * shell as lcaProduct's `ProductRegisterModal`: `TailwindSideModal` +
 * `CommonSplitContainer` + `TailwindBottomButtonView`. All state/submit
 * logic lives in `useCompanyRegisterViewModel`.
 */
const CompanyRegisterModal = ({
  visibleModal,
  closeModal,
  onSuccess
}: CompanyRegisterModalProps) => {
  const vm = useCompanyRegisterViewModel({ visibleModal, closeModal, onSuccess });

  return (
    <>
      <TailwindSideModal
        open={visibleModal}
        onOpenChange={open => {
          if (!open) vm.onCancel();
        }}
        eyebrow="Companies"
        title="Register company"
        titleClassName="tw-font-display"
        description="Set the company identity before assigning its operating details."
      >
        <FormProvider {...vm.methods}>
          <CommonSplitContainer
            currentHeight={0.86}
            overflowX="hidden"
            topChild={
              <div>
                <CompanyFormFields
                  control={vm.methods.control}
                  countries={vm.countries}
                  currencies={vm.currencies}
                  isCountriesLoading={vm.isCountriesLoading}
                  isCurrencyLoading={vm.isCurrencyLoading}
                  logoSlot={
                    <CompanyLogoUpload
                      onUpload={vm.onLogoSelect}
                      onRemove={() => vm.onLogoSelect(null)}
                    />
                  }
                />
              </div>
            }
            bottomChild={
              <TailwindBottomButtonView
                cancelButtonStatus
                saveButtonStatus
                saveTitle="Register company"
                buttonSize="lg"
                saveLoading={vm.isSaving}
                saveDisable={vm.isSaving}
                cancelButton={vm.onCancel}
                saveButton={vm.onSave}
              />
            }
          />
        </FormProvider>
      </TailwindSideModal>

      {vm.isSaving ? <LoadingOverlay /> : null}
    </>
  );
};

export default CompanyRegisterModal;
